<template>
  <b-modal
    :id="modalId"
    body-class="receipt-modal-body"
    centered
    content-class="receipt-modal-content"
    hide-footer
    hide-header
    size="md"
  >
    <div class="receipt-brand">
      <img
        alt="Komed by Komerce"
        class="receipt-brand-logo"
        src="https://storage.googleapis.com/komerce/komed/komed-by-komerce.svg"
      >
      <p class="receipt-brand-greeting">
        Thank you for your order!
      </p>
    </div>

    <div class="receipt-heading">
      <span class="receipt-heading-title">Detail Transaksi</span>
      <span class="receipt-heading-type">{{ formatDetailTransaction }}</span>
    </div>

    <div class="receipt-rows">
      <div class="receipt-row">
        <span class="receipt-label">{{ formattedDateLabel }}</span>
        <span class="receipt-value">{{ receipt.date || '-' }}</span>
      </div>
      <div
        v-if="receipt.transactionId"
        class="receipt-row"
      >
        <span class="receipt-label">ID Transaksi</span>
        <span class="receipt-value">{{ receipt.transactionId }}</span>
      </div>
      <div
        v-if="receipt.email"
        class="receipt-row"
      >
        <span class="receipt-label">Email</span>
        <span class="receipt-value">{{ receipt.email }}</span>
      </div>
      <div class="receipt-row">
        <span class="receipt-label">{{ formattedNominalLabel }}</span>
        <span class="receipt-value">{{ formattedNominal }}</span>
      </div>
    </div>

    <div class="receipt-total">
      <span>{{ formattedTotalLabel }}</span>
      <span>{{ formattedNominal }}</span>
    </div>

    <div class="receipt-actions">
      <b-button
        class="receipt-close-btn"
        variant="outline-secondary"
        @click="$bvModal.hide(modalId)"
      >
        Tutup
      </b-button>
    </div>
  </b-modal>
</template>

<script>
/**
 * Label baris dipetakan dari `activity` — bukan dari `type`, yang isinya
 * "credit"/"debit" (arah mutasi saldo), bukan jenis transaksinya.
 */
export default {
  props: {
    modalId: {
      type: String,
      default: 'modal-receipt-kredit-komed',
    },
    receipt: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    formattedNominal() {
      return `Rp${Number(this.receipt.nominal || 0).toLocaleString('id-ID')}`
    },
    formattedDateLabel() {
      if (this.receipt.activity === 'Top Up Kredit') {
        return 'Tanggal Top Up'
      }
      if (this.receipt.activity === 'Refund Kredit') {
        return 'Tanggal Refund'
      }
      return 'Tanggal Transaksi'
    },
    formattedNominalLabel() {
      if (this.receipt.activity === 'Top Up Kredit') {
        return 'Nominal Top Up'
      }
      if (this.receipt.activity === 'Refund Kredit') {
        return 'Nominal Refund'
      }
      return 'Nominal'
    },
    formattedTotalLabel() {
      if (this.receipt.activity === 'Refund Kredit') {
        return 'Total Pengembalian'
      }
      return 'Total Dibayarkan'
    },
    formatDetailTransaction() {
      const { activity } = this.receipt

      return `${activity} - ${this.formatDetailSource}`
    },
    formatDetailSource() {
      const value = this.receipt.source

      if (value === 'ai_talent') {
        return 'AI Talent'
      }
      if (value === 'motion_control_video') {
        return 'Motion Control'
      }
      if (value === 'ugc_video') {
        return 'UGC'
      }
      return '-'
    },
  },
}
</script>

<style scoped>
.receipt-brand {
  align-items: center;
  background: #eff6ff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 30px 24px;
}

/* Raster di dalam SVG-nya 2558px lebar, jadi aman diperbesar dari 133x40. */
.receipt-brand-logo {
  height: 70px;
  max-width: 100%;
  width: auto;
}

.receipt-brand-greeting {
  color: #0a0a0a;
  font-size: 19px;
  margin: 20px 0 0;
  text-align: center;
}

.receipt-heading {
  align-items: center;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  margin-top: 30px;
  padding-bottom: 20px;
}

.receipt-heading-title {
  color: #0a0a0a;
  font-size: 18px;
}

.receipt-heading-type {
  color: #0a0a0a;
  font-size: 16px;
}

/* Antar-baris tanpa garis; pembatas hanya di atas dan bawah blok. */
.receipt-rows {
  border-bottom: 1px solid #eaeaea;
  padding: 10px 0 20px;
}

.receipt-row {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 10px 0;
}

.receipt-label {
  color: #737373;
  flex-shrink: 0;
  font-size: 16px;
}

.receipt-value {
  color: #0a0a0a;
  font-size: 16px;
  text-align: right;
  word-break: break-word;
}

.receipt-total {
  align-items: center;
  color: #0a0a0a;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
}

.receipt-total span:first-child {
  font-size: 17px;
}

.receipt-total span:last-child {
  font-size: 19px;
}

.receipt-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
}

.receipt-close-btn {
  min-width: 96px;
}

/* HP: label dan nilai bertumpuk supaya nilai panjang tidak terpotong. */
@media (max-width: 575.98px) {
  .receipt-brand {
    padding: 22px 16px;
  }

  .receipt-brand-logo {
    height: 52px;
  }

  .receipt-brand-greeting {
    font-size: 19px;
    margin-top: 14px;
  }

  .receipt-value {
    text-align: left;
  }

  .receipt-actions {
    margin-top: 24px;
  }

  .receipt-close-btn {
    width: 100%;
  }
}
</style>

<style>
.receipt-modal-content {
  border-radius: 16px !important;
}

.receipt-modal-body {
  padding: 16px !important;
}
</style>
